import { useMemo, useState } from 'react'

import type { LinkType } from 'types'
import FilterableCourses from 'ui-component-library/components/FilterableCourses'

type Filter = {
  fieldId: 'regions' | 'subjects'
  inputId: string
  label: string
  options: { label: string; value: string }[]
  placeholder?: string
}

interface CourseCard {
  descriptionText: string
  headerText: string
  link: LinkType
}

interface PreferredCourseCard extends CourseCard {
  regions: string[]
  subjects: string[]
}

type FilterField = 'regions' | 'subjects'

type Props = {
  cards: PreferredCourseCard[]
  filters: Filter[]
  noResultsFoundText: string
  showFilters?: boolean
}

function PreferredCoursesContainer({ cards, ...props }: Props) {
  const [currentFilters, setCurrentFilters] = useState({
    regions: '',
    subjects: '',
  })

  function handleFilterChange(field: FilterField, value: string) {
    setCurrentFilters((cf) => ({ ...cf, [field]: value }))
  }

  const filteredCards = useMemo(() => {
    const { regions, subjects } = currentFilters
    return cards.filter(
      (card) =>
        (!regions || (card.regions && card.regions.includes(regions))) &&
        (!subjects || (card.subjects && card.subjects.includes(subjects))),
    )
  }, [cards, currentFilters])

  return (
    <FilterableCourses
      cards={filteredCards}
      handleFilterChange={handleFilterChange}
      state={currentFilters}
      {...props}
    />
  )
}

export default PreferredCoursesContainer
